import {
  RfqPcbAssemblyFileInput,
  RfqPcbFabricationFileInput,
  RfqReferenceFileInput
} from '@generated/graphql';
import { createAction } from 'typesafe-actions';
import { IRequestState, UploadedDrawingFileType } from './types';

export const CREATE_RFQ_FILE = 'request/CREATE_RFQ_FILE';
export const CREATE_REFERENCE_FILE = 'request/CRETATE_REFERENCE_FILE';
export const UPLOAD_REPRESENTIVE_IMAGE = 'request/UPLOAD_REPRESENTIVE_IMAGE';
export const DELETE_REPRESENTIVE_IMAGE = 'request/DELETE_REPRESENTIVE_IMAGE';
export const DELETE_RFQ_FILE = 'request/DELETE_RFQ_FILE';
export const UPDATE_RFQ_FILE = 'request/UPDATE_RFQ_FILE';
export const UPDATE_RFQ_INFO = 'request/UPDATE_RFQ_INFO';
export const COMPLETE_RFQ = 'request/COMPLETE_RFQ';
export const UPDATE_COMPLETE_RFQ = 'request/UPDATE_COMPLETE_RFQ';
export const INIT_RFQ_STATE = 'request/INIT_RFQ_STATE';
export const ALL_UPDATE_RFQ_FILE = 'request/ALL_UPDATE_RFQ_FILE';
export const BATCH_UPDATE_RFQ_FILE = 'request/BATCH_UPDATE_RFQ_FILE';
export const SET_PROCCESSING_STATE = 'request/SET_PROCCESSING_STATE';
export const UPDATE_PCB_FABRICATION_FILE =
  'request/UPDATE_PCB_FABRICATION_FILE';
export const UPDATE_PCB_ASSEMBLY_FILE = 'request/UPDATE_PCB_ASSEMBLY_FILE';

export const createRfqFile = createAction(CREATE_RFQ_FILE)<
  UploadedDrawingFileType
>();
export const createReferenceFile = createAction(CREATE_REFERENCE_FILE)<
  RfqReferenceFileInput & { size: number }
>();
export const uploadRepresentiveImage = createAction(UPLOAD_REPRESENTIVE_IMAGE)<
  RfqReferenceFileInput & { size: number }
>();
export const deleteRepresentiveImage = createAction(
  DELETE_REPRESENTIVE_IMAGE
)();
export const deleteRfqFile = createAction(DELETE_RFQ_FILE)<string>();
export const updateRfqFile = createAction(UPDATE_RFQ_FILE)<
  UploadedDrawingFileType
>();
export const allUpdateRfqFile = createAction(ALL_UPDATE_RFQ_FILE)<
  UploadedDrawingFileType[]
>();

export const batchUpdateRfqFile = createAction(BATCH_UPDATE_RFQ_FILE)<
  UploadedDrawingFileType
>();

export const updateRfqInfo = createAction(UPDATE_RFQ_INFO)<
  Partial<IRequestState>
>();
export const completeRfq = createAction(COMPLETE_RFQ)();
export const updateCompleteRfq = createAction(UPDATE_COMPLETE_RFQ)<boolean>();
export const initRfqState = createAction(INIT_RFQ_STATE)();
export const setProceessingState = createAction(SET_PROCCESSING_STATE)<
  boolean
>();

export const updatePcbFabricationFile = createAction(
  UPDATE_PCB_FABRICATION_FILE
)<RfqPcbFabricationFileInput[]>();
export const updatePcbAssemblyFile = createAction(UPDATE_PCB_ASSEMBLY_FILE)<
  RfqPcbAssemblyFileInput[]
>();
